import { useState, useEffect } from 'react';
import { Routes, Route, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import _ from 'lodash';

import Login from '../pages/login/index';
import FrontPage from '../pages/frontPage/index';
import WishItem from '../pages/wishItem';
import MarketingWord from '../pages/marketingWord';
import ProductList from '../pages/marketingWord/productList';
import Error from '../pages/error/index';

import { handleApiRequest, removeStorageRecord } from '../api';

import useUserAuth from '../hook/useUserAuth';
import useGlobalStatus from '../hook/useGlobalStatus';

import MainLayout from '../layout/MainLayout';

import Loading from '../components/loading/Loading';

import { SESSION_CREATE_TIME } from '../constants/global';
import { PAGE } from '../constants/url';
import { ERROR_CERTIFICATE } from '../constants/alertMsg';


const PrivateRoute = ({
  children,
  allowList,
  redirectPath = PAGE.login.path,
  path
}) => {
  const { userAuth } = useUserAuth();
  const { isLoadingLoginStatus } = useGlobalStatus();

  if (isLoadingLoginStatus && path !== redirectPath) return null;

  if (userAuth) {
    return children ? <MainLayout>{children}</MainLayout> : <Outlet />;
  }

  return <Navigate to={redirectPath} replace />;
}

const AppRoute = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { userAuth, setUserAuth, setAuthStatusMsg } = useUserAuth();
  const { isLoadingLoginStatus, setIsLoadingLoginStatus } = useGlobalStatus();
  const hasLogin = localStorage.getItem(SESSION_CREATE_TIME);

  useEffect(() => {
    if (userAuth) return;
    const currentPage = _.filter(PAGE, { path: pathname });

    if (currentPage.length > 0 && !currentPage[0].allow) {
      setIsLoadingLoginStatus(false);
      return;
    }

    handleApiRequest('checkUserStatus')
      .then(res => {
        if (res.status === 200) {
          setUserAuth({ ...res.data });

          if (pathname === PAGE.login.path) {
            navigate(PAGE[PAGE.index].path, { replace: true });
          }

        } else {
          if (hasLogin) {
            setAuthStatusMsg(ERROR_CERTIFICATE);
          }
          setUserAuth(null);
          removeStorageRecord();
          navigate(PAGE.login.path);
        }

        setIsLoadingLoginStatus(false);
      })
  }, [pathname])

  return (
    <>
      <Routes>
        <Route
          path={PAGE.login.path}
          element={<Login />}
        />

        <Route
          index
          element={
            <PrivateRoute allowList={PAGE.frontpage.allow} path={PAGE.frontpage.path}>
              <FrontPage />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE.frontpage.path}
          element={
            <PrivateRoute allowList={PAGE.frontpage.allow} path={PAGE.frontpage.path}>
              <FrontPage />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE.wishitem.path}
          element={
            <PrivateRoute allowList={PAGE.wishitem.allow} path={PAGE.wishitem.path}>
              <WishItem />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE.marketingword.path}
          element={
            <PrivateRoute allowList={PAGE.marketingword.allow} path={PAGE.marketingword.path}>
              <MarketingWord />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE.productList.path}
          element={
            <PrivateRoute allowList={PAGE.productList.allow} path={PAGE.productList.path}>
              <ProductList />
            </PrivateRoute>
          }
        />

        <Route
          path="*"
          element={<Error />}
        />

      </Routes>

      <Loading isLoading={isLoadingLoginStatus} />
    </>
  )
}

export default AppRoute;